import React from "react"
import { useDispatch } from "react-redux"
import Link from "next/link"
import CustomImage from "@/main/customImage"
import { Card, Row, Col, Button } from "react-bootstrap"

import {
    toggleMakeEnquiryModal,
    setMakeEnquiryProperty,
} from "@/slices/makeEnquiryModalSlice"

function PropertyCardGrid({ property, priority }) {
    const dispatch = useDispatch()

    // Currency formatter
    const formatter = new Intl.NumberFormat("en", {
        style: "currency",
        currency: "GBP",
        minimumFractionDigits: 0,
    })
    return (
        <Card className="p-0 mb-5 btn-card w-100">
            <Row className="h-100 g-0 mobile-marg-0">
                <Col xs={12}>
                    <Link
                        href={"/properties/" + property.property_ref}
                        passHref
                    >
                        <a>
                            <div className="property-img">
                                <CustomImage
                                    src={
                                        property.images[0]?.imgix_url ||
                                        "https://webb-jenkins-static-164679926.imgix.net/placeholder.svg"
                                    }
                                    alt={`Property ${property.property_ref} main`}
                                    layout="fill"
                                    objectFit="cover"
                                    objectPosition="center"
                                    sizes="50vw"
                                    priority={priority}
                                />
                                {property.status_id === 1 ? (
                                    <Row className="mx-0 h-100 align-items-end sstc-old-browser">
                                        <Col
                                            xs="auto"
                                            className="z-index-1 bg-danger sstc-tag"
                                        >
                                            <span className=" text-white">
                                                Sold STC
                                            </span>
                                        </Col>
                                    </Row>
                                ) : property.status_id === 5 ? (
                                    <Row className="mx-0 h-100 align-items-end sstc-old-browser">
                                        <Col
                                            xs="auto"
                                            className="z-index-1 bg-danger sstc-tag"
                                        >
                                            <span className=" text-white">
                                                Let agreed
                                            </span>
                                        </Col>
                                    </Row>
                                ) : null}
                            </div>

                            <Row className="g-0 mt-1">
                                <Col xs={4} className="property-grid-img1">
                                    <div className="property-img">
                                        {property.images[1]?.imgix_url ? (
                                            <CustomImage
                                                src={
                                                    property.images[1]
                                                        ?.imgix_url
                                                }
                                                alt={`Property ${property.property_ref} second`}
                                                layout="fill"
                                                objectFit="cover"
                                                objectPosition="center"
                                                sizes="20vw"
                                            />
                                        ) : null}
                                    </div>
                                </Col>
                                <Col xs={4} className="property-grid-img2">
                                    <div className="property-img">
                                        {property.images[2]?.imgix_url ? (
                                            <CustomImage
                                                src={
                                                    property.images[2]
                                                        ?.imgix_url
                                                }
                                                alt={`Property ${property.property_ref} third`}
                                                layout="fill"
                                                objectFit="cover"
                                                objectPosition="center"
                                                sizes="20vw"
                                            />
                                        ) : null}
                                    </div>
                                </Col>
                                <Col xs={4} className="property-grid-img3">
                                    <div className="property-img">
                                        {property.images[3]?.imgix_url ? (
                                            <CustomImage
                                                src={
                                                    property.images[3]
                                                        ?.imgix_url
                                                }
                                                alt={`Property ${property.property_ref} fourth`}
                                                layout="fill"
                                                objectFit="cover"
                                                objectPosition="center"
                                                sizes="20vw"
                                            />
                                        ) : null}
                                    </div>
                                </Col>
                            </Row>
                        </a>
                    </Link>
                </Col>

                <Col md={12}>
                    <Card.Body className="d-flex flex-column h-100 pb-0 px-sm-5">
                        <Card.Title className="btn-card align-self-start">
                            <Link href={"/properties/" + property.property_ref}>
                                <a>
                                    <span className="text-normal text-sm">
                                        {property.trans_type_id === 1 &&
                                            property.residential_sales_details &&
                                            property.residential_sales_details
                                                ?.price_qualifier !==
                                                "None" && (
                                                <>
                                                    {
                                                        property
                                                            .residential_sales_details
                                                            ?.price_qualifier
                                                    }
                                                    &nbsp; &nbsp; | &nbsp;
                                                    &nbsp;
                                                </>
                                            )}
                                        {property.property_ref}
                                    </span>
                                    <span className="h3 d-block mb-3">
                                        {formatter.format(property.price)}
                                        {property.trans_type_id === 2 &&
                                        property.residential_lettings_details
                                            ?.let_rent_frequency === 0
                                            ? " pw"
                                            : property
                                                    .residential_lettings_details
                                                    ?.let_rent_frequency === 1
                                              ? " pcm"
                                              : property
                                                      .residential_lettings_details
                                                      ?.let_rent_frequency === 2
                                                ? " per Quarter"
                                                : property
                                                        .residential_lettings_details
                                                        ?.let_rent_frequency ===
                                                    3
                                                  ? " pa"
                                                  : ""}
                                    </span>

                                    <h2 className="h4 mb-3 text-wjdarkgrey">
                                        {property.display_address}
                                    </h2>

                                    <div className="d-flex mb-4">
                                        <div>
                                            <CustomImage
                                                src={
                                                    "https://webb-jenkins-static-164679926.imgix.net/icons/bed.svg"
                                                }
                                                alt="Bed icon"
                                                height={16}
                                                width={28}
                                                className="me-1"
                                            />

                                            <span className="me-5 text-normal text-sm">
                                                {property.bedrooms} Bedroom
                                            </span>
                                        </div>

                                        {property.bathrooms > 0 && (
                                            <div>
                                                <CustomImage
                                                    src={
                                                        "https://webb-jenkins-static-164679926.imgix.net/icons/bath.svg"
                                                    }
                                                    alt="Bath icon"
                                                    height={16}
                                                    width={28}
                                                    className="me-1"
                                                />
                                                <span className=" text-normal text-sm">
                                                    {property.bathrooms}{" "}
                                                    Bathroom
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </a>
                            </Link>
                        </Card.Title>
                        <Row className="h-100 d-none d-sm-flex">
                            <Col xs={12} sm={6} className="mb-4 align-self-end">
                                <Link
                                    href={
                                        "/properties/" + property.property_ref
                                    }
                                    passHref
                                >
                                    <Col
                                        xs={12}
                                        as={Button}
                                        variant="outline-warning"
                                        className="px-3 rounded-0"
                                    >
                                        <span className="m-0 text-sm text-warning">
                                            More details
                                        </span>
                                    </Col>
                                </Link>
                            </Col>
                            <Col xs={12} sm={6} className="mb-4 align-self-end">
                                <Col
                                    xs={12}
                                    as={Button}
                                    variant="warning"
                                    className="px-3 rounded-0"
                                    onClick={() => {
                                        dispatch(toggleMakeEnquiryModal(true))
                                        dispatch(
                                            setMakeEnquiryProperty(property),
                                        )
                                    }}
                                >
                                    <span className="m-0 text-sm text-white">
                                        Make enquiry
                                    </span>
                                </Col>
                            </Col>
                        </Row>
                    </Card.Body>
                </Col>
            </Row>
        </Card>
    )
}

export default PropertyCardGrid
